var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5006 17.0006H17.7106L17.4306 16.7306C18.6306 15.3306 19.2506 13.4206 18.9106 11.3906C18.4406 8.61063 16.1206 6.39063 13.3206 6.05063C9.09063 5.53063 5.53063 9.09063 6.05063 13.3206C6.39063 16.1206 8.61063 18.4406 11.3906 18.9106C13.4206 19.2506 15.3306 18.6306 16.7306 17.4306L17.0006 17.7106V18.5006L21.2506 22.7506C21.6606 23.1606 22.3306 23.1606 22.7406 22.7506C23.1506 22.3406 23.1506 21.6706 22.7406 21.2606L18.5006 17.0006ZM12.5006 17.0006C10.0106 17.0006 8.00063 14.9906 8.00063 12.5006C8.00063 10.0106 10.0106 8.00063 12.5006 8.00063C14.9906 8.00063 17.0006 10.0106 17.0006 12.5006C17.0006 14.9906 14.9906 17.0006 12.5006 17.0006Z",
    fill: "#878F9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsearch);
export default __webpack_public_path__ + "static/media/Icon search.589984570779aa111a1fbb0ad356f371.svg";
export { ForwardRef as ReactComponent };